export const mergeSets = <El extends any>(sets: Array<Set<El>> | undefined): Set<El> => {
  if (!sets) {
    return new Set<El>()
  }

  return sets.reduce((accumulator, current) => {
    current.forEach(element => accumulator.add(element))
    return accumulator
  }, new Set<El>())
}

export const mapSet = <El extends any, MapperResult extends any>(
  set: Set<El>,
  mapper: (el: El) => MapperResult
): Set<MapperResult> => {
  const result = new Set<MapperResult>()

  set.forEach(element => result.add(mapper(element)))

  return result
}
